import React from "react";
import type { KendoTooltipTitleRenderProps } from "@/helpers/kendoTooltip";
import "./styles.scss";

/**
 * Kendo Tooltip `content` for a `title` shown as plain text, never parsed as
 * HTML. Hints carry API- and admin-entered strings (attribute descriptions,
 * metadata messages), so markup in them must render literally. A blank line
 * (`\n\n`) in the text is the way to break it into paragraphs.
 */
export const renderTooltipText = ({ title }: KendoTooltipTitleRenderProps) => (
  <span className="tlx-tooltip-text">{title}</span>
);
